import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private subject = new Subject<any>();

  constructor() {}
  getAlert(): Observable<any> {
    return this.subject.asObservable();
  }

  success(message: string, keepAfterRouteChange = false): void {
    this.subject.next({ type: 'success', text: message });
  }

  error(message: string, keepAfterRouteChange = false): void {
    this.subject.next({ type: 'error', text: message });
  }

  clear(): void {
    // clear by calling subject.next() without parameters
    this.subject.next();
  }
}
